import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const services = [
  {
    icon: 'ri-user-smile-line',
    title: 'Figurines Personnalisées',
    description:
      'Immortalisez vos proches sous forme de figurines 3D uniques, fabriquées avec précision et détail.',
    image:
      'https://readdy.ai/api/search-image?query=custom%203D%20printed%20figurines%20personalized%20miniature%20human%20figurines%20detailed%20colorful%20white%20background%20elegant%20studio%20photography%20gift%20keepsake%20high%20quality&width=380&height=260&seq=evco_3d001&orientation=landscape',
  },
  {
    icon: 'ri-gift-2-line',
    title: 'Objets Personnalisés',
    description:
      "Vases, cadres, pièces décoratives… Chaque objet est conçu sur mesure pour correspondre à votre vision.",
    image:
      'https://readdy.ai/api/search-image?query=custom%203D%20printed%20decorative%20objects%20vases%20frames%20elegant%20home%20decor%20white%20minimalist%20background%20studio%20photography%20luxury%20personalized%20gifts&width=380&height=260&seq=evco_3d002&orientation=landscape',
  },
  {
    icon: 'ri-shopping-bag-3-line',
    title: 'Goodies & Cadeaux',
    description:
      "Créez des goodies originaux pour vos événements, entreprises ou offrir à vos proches des cadeaux inoubliables.",
    image:
      'https://readdy.ai/api/search-image?query=3D%20printed%20branded%20goodies%20corporate%20gifts%20keychains%20magnets%20colorful%20custom%20logo%20items%20professional%20studio%20photography%20elegant%20white%20background&width=380&height=260&seq=evco_3d003&orientation=landscape',
  },
  {
    icon: 'ri-building-4-line',
    title: 'Éléments Décoratifs',
    description:
      "Lettres décoratives, sculptures miniatures, éléments architecturaux — la 3D au service de votre décoration.",
    image:
      'https://readdy.ai/api/search-image?query=3D%20printed%20decorative%20letters%20architectural%20miniatures%20sculptures%20home%20decor%20modern%20elegant%20white%20gold%20studio%20photography%20luxury%20interior%20design%20elements&width=380&height=260&seq=evco_3d004&orientation=landscape',
  },
];

const ServicesShowcase = () => {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section className="bg-white py-24 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 mb-4">
            <span className="h-px w-6 bg-brand-coral" />
            <span className="text-brand-coral text-xs font-medium tracking-[0.2em] uppercase">
              Ce que nous créons
            </span>
            <span className="h-px w-6 bg-brand-coral" />
          </div>
          <h2 className="font-serif text-4xl lg:text-5xl text-brand-anthracite mb-4">
            Nos Créations 3D
          </h2>
          <p className="text-brand-gray max-w-xl mx-auto text-base leading-relaxed">
            De la conception numérique à l'objet tangible, nous donnons vie à vos idées les plus créatives avec une précision remarquable.
          </p>
        </div>

        <div ref={ref} className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {services.map((svc, idx) => (
            <div
              key={svc.title}
              className={`group bg-brand-beige rounded-2xl overflow-hidden flex flex-col md:flex-row transition-all duration-600 hover:-translate-y-1 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
              }`}
              style={{ transitionDelay: `${idx * 120}ms`, transitionDuration: '600ms' }}
            >
              {/* Image */}
              <div className="w-full md:w-44 h-48 md:h-auto flex-shrink-0 overflow-hidden">
                <img
                  src={svc.image}
                  alt={svc.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              {/* Content */}
              <div className="p-6 flex flex-col justify-center">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-brand-fuchsia">
                    <i className={`${svc.icon} text-white text-base`} />
                  </div>
                  <h3 className="font-serif text-lg font-semibold text-brand-anthracite">
                    {svc.title}
                  </h3>
                </div>
                <div className="h-px w-8 bg-brand-gold/40 mb-3" />
                <p className="text-sm text-brand-gray leading-relaxed">{svc.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesShowcase;
